import { createContext, useContext } from 'react';
import type { Progress } from '@ofc/shared';
import type { useAccount } from './auth';

export type AccountApi = ReturnType<typeof useAccount>;

export interface AccountContextValue {
  account: AccountApi | null;
  /**
   * Their progress as it stood when this game began, so the end screen can show
   * what the game was worth. Null for a guest, or before it has loaded.
   */
  baseline: Progress | null;
  setBaseline(progress: Progress | null): void;
}

/**
 * The signed-in player, for screens deep inside a game that would otherwise
 * need it threaded down through every room component.
 */
export const AccountContext = createContext<AccountContextValue>({
  account: null,
  baseline: null,
  setBaseline: () => {},
});

export function useAccountContext(): AccountContextValue {
  return useContext(AccountContext);
}
